module.exports = __webpack_public_path__ + "static/media/voiceVideo.9c01a196.mp4";